/* unplugin-vue-components disabled */import script from "./NotificationDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationDialog.vue?vue&type=style&index=0&id=659d53c5&lang=less"
import "./NotificationDialog.vue?vue&type=style&index=1&id=659d53c5&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659d53c5"]])

export default __exports__